import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faBoxOpen} from '@fortawesome/free-solid-svg-icons';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ContainerType, IContainerType} from 'app/blocks/model/container-type.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ContainerTypeService} from 'app/blocks/service/api/container-type.service';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ContainerTypeResource extends AbstractEntityResource<IContainerType> {
    constructor(containerTypeService: ContainerTypeService, router: Router) {
        super(
            Resource.CONTAINER_TYPES,
            containerTypeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CONTAINER_TYPES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CONTAINER_TYPES),
            (entity?) => new ContainerType(entity),
            (entity) => entity.id,
            faBoxOpen
        );
    }
}
